import React, {useState, useRef, useEffect} from "react";
import {InputText} from 'primereact/inputtext';
import {Toast} from "primereact/toast";
import {DataTable} from 'primereact/datatable';
import {Accordion, AccordionTab} from 'primereact/accordion';
import {Column} from 'primereact/column';
import axios from "axios";
import FileExport from "../FileExport";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";

const pdfMake = require('pdfmake/build/pdfmake.js');
const pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const ReportManagement = (props) => {
    const toast = useRef(null);
    const [globalFilter1, setGlobalFilter1] = useState('');
    const [userList, setUserList] = useState([]);
    const [competitionList, setCompetitionList] = useState([]);
    const [competitiorList, setCompetitiorList] = useState([]);
    //e bulten
    const [pdfContent, setPdfContent] = useState([]);
    const [csvContent, setCsvContent] = useState([]);
    const [fileDataContent, setFileDataContent] = useState([]);
    //yarısma
    const [compPdfContent, setCompPdfContent] = useState([]);
    const [compCsvContent, setCompCsvContent] = useState([]);
    const [compFileDataContent, setCompFileDataContent] = useState([]);
    //yarışmacı
    const [competitorPdfContent, setCompetitorPdfContent] = useState([]);
    const [competitorCsvContent, setCompetitorCsvContent] = useState([]);
    const [competitorFileDataContent, setCompetitorFileDataContent] = useState([]);
    const report_list = localStorage.getItem('report_list') ? true : false;


    useEffect(() => {
        getUserList();
        getCompetition();
        getCompetitior();

    }, []);


    const getUserList = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/md-user/', {"headers": headers})
            .then(res => {
                setUserList(res.data.user_list)
                //console.log(res.data.user_list, "----")
                file_exporf_json_edit(res.data.user_list);
                // comp_file_exporf_json_edit(res.data.user_list);

            })
    }
    const getCompetition = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/competition/', {"headers": headers})
            .then(res => {

                setCompetitionList(res.data.competition_list)
                //console.log(competitionList, "*****")
                comp_file_exporf_json_edit(res.data.competition_list);


            })
            .then(res => {
                if (res.status === 401) {
                    props.loadUser();
                    throw res.data;
                } else if (res.status === 403) {
                    throw res.data;
                }
            })
    }
    const getCompetitior = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/competitior/', {"headers": headers})
            .then(res => {

                setCompetitiorList(res.data.comp_competitor)
                competitor_file_exporf_json_edit(res.data.comp_competitor);
            })
    }

    const customer1TableHeader2 = (
        <div className="table-header" align="right">

            <span className="p-input-icon-left">
                <i className="pi pi-search"/>
                <InputText value={globalFilter1} onChange={(e) => setGlobalFilter1(e.target.value)}
                           placeholder="Genel Arama"/>
            </span>
        </div>
    );
    const customer1TableHeader = (
        <div className="table-header" align="right">

            <span className="p-input-icon-left">
                <i className="pi pi-search"/>
                <InputText value={globalFilter1} onChange={(e) => setGlobalFilter1(e.target.value)}
                           placeholder="Genel Arama"/>
            </span>
        </div>
    );

    const file_exporf_json_edit = (userList) => {
        let file_data = []
        userList.map(report =>
            file_data.push({
                sub_id: report['sub_id'],
                sub_email: report['sub_email'],
                sub_createtime: report['sub_createtime']
            },)
        )
        setFileDataContent(file_data)
        setPdfContent({
            pdf_name: 'e-Bülten Kayıtlı Kullanıcılar.pdf',
            widths: ['35%', '35%', '40%'],
            body_text:
                [
                    {text: 'ID', bold: true},
                    {text: 'E-mail', bold: true},
                    {text: 'Kayıt Zamanı', bold: true},
                ],
            body_cell:
                ['sub_id', 'sub_email', 'sub_createtime']
        },)
        setCsvContent({
            csv_name: 'e-Bülten Kayıtlı Kullanıcılar.csv',
        })
    }

    const comp_file_exporf_json_edit = (competitionList) => {
        let file_data = []
        competitionList.map(report =>
            file_data.push({
                comp_id: report['comp_id'],
                comp_name: report['comp_name'],
                comp_createtime: report['comp_createtime']
            },)
        )
        setCompFileDataContent(file_data)
        setCompPdfContent({
            pdf_name: 'Yarışmalar.pdf',
            widths: ['35%', '35%', '40%'],
            body_text:
                [
                    {text: 'ID', bold: true},
                    {text: 'Yarışma Adı', bold: true},
                    {text: 'Oluşturulma Zamanı', bold: true},
                ],
            body_cell:
                ['comp_id', 'comp_name', 'comp_createtime']
        },)
        setCompCsvContent({
            csv_name: 'Yarışmalar.csv',
        })
    }
    const competitor_file_exporf_json_edit = (competitiorList) => {
        let file_data = []
        competitiorList.map(report =>
            file_data.push({
                comp_id: report['comp_id'],
                cmpt_id: report['cmpt_id'],
                comp_name: report['comp_name'],
                cmpt_name: report['cmpt_name'],
                cmpt_surname: report['cmpt_surname'],
                cmpt_email: report['cmpt_email'],
                comp_createtime: report['comp_createtime'],
                cmpt_createtime: report['cmpt_createtime']
            },)
        )
        setCompetitorFileDataContent(file_data)
        setCompetitorPdfContent({
            pdf_name: 'Yarışmacılar.pdf',
            widths: ['17%', '17%', '17%', '17%', '17%', '17%', '17%%', '12%'],
            body_text:
                [
                    {text: 'Yarışma ID', bold: true},
                    {text: 'Yarışmacı ID', bold: true},
                    {text: 'Yarışma Adı', bold: true},
                    {text: 'Yarışmacı Adı', bold: true},
                    {text: 'Yarışmacı Soyadı', bold: true},
                    {text: 'Yarışmacı Mail', bold: true},
                    // {text: 'Yarışma Oluşturulma Zamanı', bold: true},
                    // {text: 'Yarışmacı Oluşturulma Zamanı', bold: true},

                ],
            //, 'cmpt_email', 'comp_createtime', 'cmpt_createtime'
            body_cell:
                ['comp_id', 'cmpt_id', 'comp_name', 'cmpt_name', 'cmpt_surname', 'cmpt_email']
        },)
        setCompetitorCsvContent({
            csv_name: 'Yarışmacılar.csv',
        })
    }

    if (report_list) {
        return (
            <div className="datatable-doc-demo">
                <Toast ref={toast}/>
                <Accordion>
                    <AccordionTab header="e-Bülten Kayıtlı Kullanıcılar Listesi">
                        <div className="card">
                            <div className="p-col-12 p-sm-6 p-md-6 p-lg-2">
                                <FileExport file_data={fileDataContent} pdf_content={pdfContent}
                                            csv_content={csvContent}/>
                            </div>


                        </div>
                        <div className="datatable-responsive-demo">

                            <div className="card">
                                <h5><b>e-Bülten Kayıtlı Kullanıcılar</b></h5>
                                <p>Sayfalandırma, sıralama ve filtreleme </p>
                                <div className="p-grid p-justify-end" style={{marginTop: '1px'}}>

                                </div>
                                <DataTable
                                    value={userList}
                                    paginator
                                    className="p-datatable-responsive-demo"
                                    rows={10} dataKey="id"
                                    rowHover
                                    globalFilter={globalFilter1} emptyMessage="Kayıt Bulunamadı."
                                    header={customer1TableHeader}
                                >

                                    <Column field={'sub_id'}
                                            header="ID"
                                            filter
                                            sortable
                                    />


                                    <Column
                                        field={'sub_email'}
                                        header="E-Mail"
                                        sortable
                                        filter
                                        style={{fontWeight: 'bold'}}


                                    />
                                    <Column
                                        field={'sub_createtime'}
                                        header="Kayıt Zamanı"
                                        sortable
                                        filter


                                    />


                                </DataTable>
                            </div>
                        </div>
                    </AccordionTab>

                    <AccordionTab header="Aktif Yarışma Listesi">
                        <div className="card">
                            <div className="p-col-12 p-sm-6 p-md-6 p-lg-2">
                                <FileExport file_data={compFileDataContent} pdf_content={compPdfContent}
                                            csv_content={compCsvContent}/>
                            </div>


                        </div>
                        <div className="datatable-responsive-demo">

                            <div className="card">
                                <h5><b>Aktif Yarışma Listesi</b></h5>
                                <p>Sayfalandırma, sıralama ve filtreleme </p>
                                <DataTable
                                    value={competitionList}
                                    paginator
                                    className="p-datatable-responsive-demo"
                                    rows={10} dataKey="id"
                                    rowHover
                                    globalFilter={globalFilter1} emptyMessage="Kayıt Bulunamadı."
                                    header={customer1TableHeader2}
                                >

                                    <Column
                                        field={'comp_id'}
                                        header="Yarışma No"


                                    />

                                    <Column field={'comp_name'}
                                            header="Yarışma Adı"


                                    />
                                    <Column
                                        field={'comp_shortname'}
                                        header="Yarışma Kısa Adı"
                                        sortable


                                    />


                                    <Column
                                        field={'comp_createtime'}
                                        header="Yarışma Oluşturulma Zamanı"
                                        sortable


                                    />

                                </DataTable>
                            </div>
                        </div>
                    </AccordionTab>
                    <AccordionTab header="Yarışmacı Listesi">
                        <div className="card">
                            <div className="p-col-12 p-sm-6 p-md-6 p-lg-2">
                                <FileExport file_data={competitorFileDataContent} pdf_content={competitorPdfContent}
                                            csv_content={competitorCsvContent}/>
                            </div>


                        </div>
                        <div className="datatable-responsive-demo">

                            <div className="card">
                                <h5><b>Yarışmacı Listesi</b></h5>
                                <p>Sayfalandırma, sıralama ve filtreleme </p>
                                <DataTable
                                    value={competitiorList}
                                    paginator
                                    className="p-datatable-responsive-demo"
                                    rows={10} dataKey="id"
                                    rowHover
                                    globalFilter={globalFilter1} emptyMessage="Kayıt Bulunamadı."
                                    header={customer1TableHeader2}
                                >

                                    <Column
                                        field={'cmpt_id'}
                                        header="Yarışmacı ID"


                                    />

                                    <Column field={'cmpt_name'}
                                            header="Yarışmacı Adı"


                                    />
                                    <Column
                                        field={'cmpt_surname'}
                                        header="Yarışmacı Soyadı"
                                        sortable


                                    />


                                    <Column
                                        field={'cmpt_email'}
                                        header="Yarışmacı E-Mail"
                                        sortable


                                    />
                                    <Column
                                        field={'comp_name'}
                                        header="Yarışma Adı"
                                        sortable


                                    />
                                    <Column
                                        field={'cmpt_createtime'}
                                        header="Kayıt Zamanı"
                                        sortable


                                    />

                                </DataTable>
                            </div>
                        </div>
                    </AccordionTab>


                </Accordion>


            </div>


        );


    } else {
        return (
            window.location.hash = "/notfound"
            // <Redirect to="#notfound"/>
        )
    }
}


const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportManagement);



// WEBPACK FOOTER //
// ./src/pages/reportmanagement/ReportManagement.jsx